import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import Panel from 'Components/Panel/Panel';
import { useEffect, useState } from 'react';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import InputField from 'Components/Input/InputField';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import TextAreaField from 'Components/TextAreaField/TextAreaField';
import ComboBox from 'Components/ComboBox/ComboBox';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import MandatoryIconField from 'Components/MandatoryIconField';

const NewSalaryMonthPanel = ({
    itemInValidation,
    dsItem,
    currentMonth,
    showNewSalaryMonthPanel,
    onUpdatePanelCostSpreadsheet,
    onUpdateShowNewItemMonthPanel,
    onUpdateReloadSalaryBenefitsCost
}) => {
    const [salary, setSalary] = useState(null)
    const [overtime, setOvertime] = useState(0)
    const [isRealValue, setIsRealValue] = useState(null)
    const [isAutomaticCalculation, setIsAutomaticCalculation] = useState('N')

    const [employeeId, setEmployeeId] = useState(null);
    const [employees, setEmployees] = useState(null);

    const [loadingNewSalaryMonthPanel, setLoadingSalaryMonthPanel] = useState(null);

    useEffect(() => {
        resetVariables();
        const fetchData = async () => {
            const employees = await ExecuteAxios.api('get', '/salary-month/lookup/employee/');
            setEmployees(employees);
        };

        fetchData();
    }, [showNewSalaryMonthPanel]);

    const employeeOptions = OptionsDataByAttributePath(employees, ['employeeName'], null, true)

    const panelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
    };

    const styleButtonsMonth = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        alignItems: 'center'
    }

    function cancelFunction() {
        onUpdateShowNewItemMonthPanel(false);
        resetVariables();
    }

    function resetVariables() {
        setSalary(null);
        setOvertime(null);
        setIsAutomaticCalculation(null)
        setIsRealValue(null)
    }

    async function postFunction() {
        try {
            setLoadingSalaryMonthPanel(true)
            const response = await ExecuteAxios.api('post', `/salary-month/insert-salary-month/`, {
                employeeId: employeeId,
                currentMonth, currentMonth,
                salary: salary,
                overtime: overtime,
                isRealValue: isRealValue,
                isAutomaticCalculation: isAutomaticCalculation
            });

            if (response) {
                onUpdatePanelCostSpreadsheet(true)
                onUpdateReloadSalaryBenefitsCost(true)
                resetVariables();
                onUpdateShowNewItemMonthPanel(false)
            }

            return response
        } finally {
            setLoadingSalaryMonthPanel(false)
        }
    }

    const styleColumnAttributes = {
        display: 'flex',
        width: '100%',
        flexWrap: 'wrap'
    }

    const handleCheckboxIsAutomaticCalculation = (value) => {
        setIsAutomaticCalculation(value === 'S' ? 'N' : 'S');
    };

    const handleCheckboxChangeIsRealValue = (value) => {
        setIsRealValue(value === 'S' ? 'N' : 'S');
    };

    return (
        <MiddlePanel isVisible={showNewSalaryMonthPanel}>
            <LoadingIndicator loaded={!loadingNewSalaryMonthPanel}>
                <Panel style={{
                    width: '420px',
                    height: '100%',
                    padding: '5px',
                    borderRadius: '10px',
                    backgroundColor: '#f5f5f5;',
                    border: '1px solid #ccc',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)'
                }}>
                    <Panel titlePage={'Novo item'}
                        style={panelListStyle}
                        canViewCRUD={true}
                        postFunction={postFunction}
                        cancelFunction={cancelFunction}
                        enableNewRecord={true}
                        canNewRecord={true}
                        enableDelete={true}
                        canDelete={true}
                        recordsSelected={[]}
                        inserting={true}>
                        <Panel style={styleButtonsMonth}>
                            <div style={styleColumnAttributes}>

                                <div id='attribute-control'>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <label>Colaborador</label>
                                        <MandatoryIconField />
                                    </div>
                                    <ComboBox
                                        setAttribute={setEmployeeId}
                                        optionsData={employeeOptions}
                                        value={employeeId}
                                        defaultValue={employeeId}
                                    />
                                </div>

                                <div id='attribute-control'>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <span className='span-role-control'>Salário</span>
                                        <MandatoryIconField />
                                    </div>
                                    <InputField
                                        setAttribute={setSalary}
                                        value={salary}
                                        readOnly={false}
                                        mask={'money'}
                                        disabled={false}
                                        style={{ width: '150px' }}
                                    />
                                </div>

                                <div id='attribute-control'>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <span className='span-role-control'>Hora extra</span>
                                        <MandatoryIconField />
                                    </div>
                                    <InputField
                                        setAttribute={setOvertime}
                                        value={overtime}
                                        readOnly={false}
                                        disabled={false}
                                        style={{ width: '150px' }}
                                    />
                                </div>

                                <div id='attribute-control'>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <span className='span-role-control'>Valor real</span>
                                        <MandatoryIconField />
                                    </div>
                                    <InputField
                                        setAttribute={handleCheckboxChangeIsRealValue}
                                        value={isRealValue}
                                        checked={isRealValue === 'S'}
                                        readOnly={false}
                                        disabled={false}
                                        type="checkbox"
                                        style={{ cursor: 'pointer' }}
                                    />
                                </div>

                                <div id='attribute-control'>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <span className='span-role-control'>Cálculo automático</span>
                                    </div>
                                    <InputField
                                        setAttribute={handleCheckboxIsAutomaticCalculation}
                                        value={isAutomaticCalculation}
                                        checked={isAutomaticCalculation === 'S'}
                                        readOnly={false}
                                        disabled={false}
                                        type="checkbox"
                                        style={{ cursor: 'pointer' }}
                                    />
                                </div>
                            </div >
                        </Panel>
                    </Panel>
                </Panel>
            </LoadingIndicator>
        </MiddlePanel >
    );
}

export default NewSalaryMonthPanel;
